import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { DialogContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { BatchInProgressIndicator } from '~/modules/common/components';

const useBatchInProgressIndicatorStyles = makeStyles(theme => ({
  container: {
    height: '100%'
  }
}));

const useStyles = makeStyles(theme => ({
  content: {
    minWidth: theme.spacing(71.25)
  }
}));

const BulkAssignTasksDialogContent = ({
  dialogDescribedById,
  impactedTaskCount,
  resourceName,
  isBulkAssignTasksInProgress
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const batchIndicatorClasses = useBatchInProgressIndicatorStyles();

  return (
    <DialogContent id={dialogDescribedById} className={classes.content}>
      {isBulkAssignTasksInProgress ? (
        <BatchInProgressIndicator
          messageId="taskAssignmentBulkActionDialog.assigningTasks"
          classes={batchIndicatorClasses}
        />
      ) : (
        <Typography>
          {formatMessage(
            {
              id: 'taskAssignmentBulkActionDialog.assignAllTasksConfirmation'
            },
            { impactedTaskCount, resourceName }
          )}
        </Typography>
      )}
    </DialogContent>
  );
};

BulkAssignTasksDialogContent.propTypes = {
  dialogDescribedById: PropTypes.string.isRequired,
  impactedTaskCount: PropTypes.number.isRequired,
  resourceName: PropTypes.string.isRequired,
  isBulkAssignTasksInProgress: PropTypes.bool
};

export default BulkAssignTasksDialogContent;
